<template>
    <v-select
        v-model="selected"
        multiple
        class="bg-white"
        label="title"
        :placeholder="$t('Component(Grid):column-business-roles')"
        :options="options"
        @input="onChange"
    />
</template>

<script>
import vSelect from 'vue-select'
import {SupplyChain} from "@core/api";

export default {
    components: {
        vSelect
    },
    props: {
        initialValue: {
            default() {
                return []
            }
        }
    },
    data() {
        return {
            selected: [],
            options: [],
            timer: null
        };
    },
    methods: {
        clear() {
            this.selected.splice(0);
        },
        onChange() {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                this.$emit('search', this.selected);
            }, 600);
        }
    },
    mounted() {
        SupplyChain.getBusinessRoles().then(r => {
            r.data.forEach(br => {
                if (br.children) {
                    br.children.forEach(r => {
                        this.options.push(r);
                        if (this.initialValue.includes(r.id)) {
                            this.selected.push(r);
                        }
                    });
                } else {
                    this.options.push(br);
                }
            });
        });
    }
}
</script>
